import React from "react";
import { Modal } from "@components";
import { Form } from "./form";
import { Access, System, useRequestContext } from "../../../../../context";

interface Props {
  open: boolean;
  selectedSystem: {
    system: System;
    access: Access;
  };
  onSubmit: (details: System, error: boolean) => void;
  onClose: () => void;
}

export const EditModal: React.FC<Props> = ({
  open,
  selectedSystem,
  onSubmit,
  onClose,
}) => {
  const { system, access } = selectedSystem;
  const [, requestContextDispatch] = useRequestContext();
  const submit = (access: any) => {
    requestContextDispatch({
      type: "update-system-access",
      system: selectedSystem.system,
      access: selectedSystem.access,
      data: access,
    });
    onClose();
  };

  return (
    <Modal isOpen={open}>
      <Form
        onUpdateAccess={submit}
        onError={() => {}}
        onCancel={onClose}
        application={system.application}
        access={access}
        accesses={system.accesses}
      ></Form>
    </Modal>
  );
};
